// Asset locali del brand — centralizzati qui per evitare di ripetere
// require('../../../assets/...') con path relativi diversi in ogni file
// che usa il logo. Per cambiare il logo (rebranding), basta aggiornare
// SOLO questo file: tutti gli import a valle restano invariati.
//
// NOTA: require() viene risolto e bundlato al build time — un cambio qui
// richiede una nuova build (eas build), non basta un OTA update.

export const LOGO = require('../assets/logo_noscritta_nosfondo.png')